import { DetailedHTMLProps, TextareaHTMLAttributes, useCallback } from 'react';
import './textarea.scss';

type TextareaProps = {
  // - キーハンドラ -
  handlerEnter?: () => void,
  limit?: number,
} & DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>;

export const TextArea = (props: TextareaProps) => {
  const { handlerEnter, limit, ...defaultProps } = props;
  // - Callback -
  // -- キー --
  const handlerKeyPress = useCallback((e) => {
    if (defaultProps.onKeyPress) {
      defaultProps.onKeyPress(e);
    }
    if (handlerEnter && (e as KeyboardEvent)?.key === 'Enter') {
      handlerEnter();
    }
  }, [handlerEnter]);
  
  if (limit) {
    return (
      <div className="limitable_textarea_wrap textarea">
        <textarea
          {...defaultProps}
          onKeyPress={handlerKeyPress}
          className={`textarea ${defaultProps.className || ''}`}
          onChange={(e) => {
            e.target.value = e.target.value.replaceAll('\r', '');
            if (e.target.value.length > limit) {
              e.target.value = e.target.value.slice(0, limit);
            }
            defaultProps.onChange?.(e);
          }}
        />
        <div className="limit_label">
          <span className={`${`${defaultProps.value || ''}`.length === limit ? 'count_limit' : ''}`}>
            {`${defaultProps.value || ''}`.length}
          </span>
          <span>
            &nbsp;/&nbsp;
          </span>
          <span>
            {limit}
          </span>
        </div>
      </div>
    )    
  }

  return (
    <textarea
      {...defaultProps}
      onKeyPress={handlerKeyPress}
      className={`textarea ${defaultProps.className || ''}`}
    />
  );
};
